import SessionStore from 'stores/SessionStore';
import ROLES from 'constants/UserRoles';

export const payloadMappingOnlyForChanges = (initData, changedData) => {
  const payload = {};
  Object.keys(initData).forEach((key) => {
    if (initData[key] !== changedData[key]) {
      payload[key] = changedData[key];
    }
  });
  return payload;
};

export const checkPermissonForEditShipperBillingModule = () => {
  const loggedInUser = SessionStore.getUser();
  /**
   * if user type is Shipper or Admin with role finance-admin or role shipper-onboarding.
   * He can edit billing module else not.
   */
  if (
    loggedInUser._type === ROLES.SHIPPER ||
    loggedInUser.roles.includes(ROLES.FINANCE_ADMIN) ||
    loggedInUser.roles.includes(ROLES.SHIPPER_ONBOARDING)
  ) {
    return true;
  }
  return false;
};
